import {Component} from '@angular/core';
import {IonicPage, Loading, LoadingController, NavController, NavParams, ToastController} from 'ionic-angular';

import {AlertProvider} from '../../providers/alert/alert';
import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {MainPage} from "../main/main";
import {QuizzListPage} from "../quizz-list/quizz-list";

/**
 * Generated class for the QuizzAboutPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-quizz-about',
  templateUrl: 'quizz-about.html',
})
export class QuizzAboutPage {

  loader: Loading;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private quizzServerProvider: QuizzServerProvider,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private eventEmitterProvider: EventEmitterProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuizzAboutPage');
  }

  doContract(id: number) {
    const that = this;

    this.alertProvider.doConfirm('Confirma a habilitação da Certificação Continuada?', () => {

      that.loader = that.loadingCtrl.create({
        content: 'Habilitando a Certificação Continuada...'
      });
      that.loader.present();

      that.quizzServerProvider.contract(id).subscribe((data: any) => {
        that.loader.dismiss();

        if ((data) && (data.action)) {
          switch (data.action) {
            case 'quizz_contracted':
              const toast = that.toastCtrl.create({
                message: 'A Certificação Continuada foi habilitada.',
                duration: 3000,
                position: 'bottom'
              });
              toast.present();

              that.eventEmitterProvider.get('can_contract_quizz').emit(false);
              this.quizzServerProvider.setCanContractQuizz(false);
              that.eventEmitterProvider.get('has_quizz').emit();

              that.navCtrl.setRoot(MainPage);
              that.navCtrl.popToRoot({
                animation: 'ios-transition'
              }, () => {
                that.eventEmitterProvider.get('do_update').emit();
                that.navCtrl.push(QuizzListPage, null, {
                  animation: 'ios-transition'
                });
              });
              break;
            default:
              that.alertProvider.doAlert('Não foi possível solicitar a habilitação da Certificação Continuada.', 'Atenção');
              break;
          }
        } else {
          that.alertProvider.doAlert('Não foi possível solicitar a habilitação da Certificação Continuada.', 'Atenção');
        }
      }, (error: any) => {
        that.loader.dismiss();
        console.log(error);
        that.alertProvider.doAlert('Não foi possível solicitar a habilitação da Certificação Continuada.', 'Atenção');
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizz-about/quizz-about.ts